import React from "react";

// "light"/"default" mantém o logo colorido atual (fundo claro do header/footer).
// "gold" é a versão mono dourada, usada onde faz falta um logo de traço único.
const SOURCES = {
  default: "/brand/mnaief-logo-256.png",
  light: "/brand/mnaief-logo-256.png",
  gold: "/brand/mnaief-logo-mono-gold.png",
};

export const Logo = ({ className = "", size = "md", variant = "default" }) => {
  // size controls height in pixels; width is auto to preserve aspect ratio
  const heights = { sm: 36, md: 52, lg: 72, xl: 78 };
  const h = heights[size] ?? heights.md;
  const src = SOURCES[variant] ?? SOURCES.default;

  return (
    <a
      href="/"
      data-testid="brand-logo"
      className={`inline-flex items-center group ${className}`}
      aria-label="M NAIEF Brindes Personalizados"
    >
      <img
        src={src}
        alt="M NAIEF Brindes Personalizados"
        className="shrink-0 object-contain transition-transform duration-300 group-hover:scale-[1.03]"
        style={{ height: h, width: "auto" }}
        loading="eager"
        decoding="async"
      />
    </a>
  );
};

export default Logo;
